import React, { useState } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { updatePot } from '../../../api/api_pots';

const AdvancedPotSettings = () => {
    const { translations } = useLanguage();
    const location = useLocation();
    const { hubSN, potSN, pot } = location.state;
    const [max_Temperature, setMax_Temperature] = useState(pot.max_temperature);
    const [sunlightLevel, setSunlightLevel] = useState(pot.sunlight_level);
    const [max_GroundHumidity, setMax_GroundHumidity] = useState(pot.max_ground_humidity);
    const [max_AirHumidity, setMax_AirHumidity] = useState(pot.max_air_humidity);
    const [max_Minerals, setMax_Minerals] = useState(pot.max_minerals);
    const [min_Temperature, setMin_Temperature] = useState(pot.min_temperature);
    const [min_GroundHumidity, setMin_GroundHumidity] = useState(pot.min_ground_humidity);
    const [min_AirHumidity, setMin_AirHumidity] = useState(pot.min_air_humidity);
    const [min_Minerals, setMin_Minerals] = useState(pot.min_minerals);
    const navigate = useNavigate();

    const sunlightLevelOptions = [
        { value: 0, label: translations.no_light },
        { value: 1, label: translations.low_ambient_light },
        { value: 2, label: translations.ambient_light },
        { value: 3, label: translations.indirect_solar_light },
        { value: 4, label: translations.direct_solar_light }
    ];

    const handleSave = async (potSN) => {
        const token = localStorage.getItem('userToken');
        const updatedDevice = {
            pot_sensor_device_MAC: pot.pot_sensor_device_MAC,
            plant_ids: pot.plant_ids,
            custom_plant_ids: pot.custom_plant_ids,
            name: pot.name,
            irrigation_plan_times: pot.irrigation_plan_times,
            irrigation_plan_hour: pot.irrigation_plan_hour,
            irrigation_out_index: pot.irrigation_out_index,
            max_temperature: max_Temperature,
            sunlight_level: sunlightLevel,
            max_ground_humidity: max_GroundHumidity,
            max_air_humidity: max_AirHumidity,
            max_minerals: max_Minerals,
            min_temperature: min_Temperature,
            min_ground_humidity: min_GroundHumidity,
            min_air_humidity: min_AirHumidity,
            min_minerals: min_Minerals,
            measure_times: pot.measure_times,
            send_times: pot.send_times,
        };
        try {
            await updatePot(pot.id, updatedDevice, true, token, potSN);
            alert(translations.pot_updated_successfully);
            navigate(-1);
        } catch (error) {
            alert(translations.failed_to_update_pot);
        }
    };

    const validateTemperatureInput = value => {
        if (value === '' || /^-?\d+\.?[05]?$/.test(value)) {
            return value;
        }
        return undefined;
    };

    const handleTemperatureChange = (value, setter) => {
        const validValue = validateTemperatureInput(value);
        if (validValue !== undefined) {
            setter(validValue);
        }
    };

    const handleBack = () => navigate(-1);
    
    return (
        <>
        <div className="sm-page">
            <div className="sm-container">
                <div className="header">
                    <button onClick={handleBack} className="back-button">&#8592;</button>
                    <h1>{translations.advanced_settings}</h1>
                </div>
                <div className="form-container">
                    <div className="input-group">
                        <label htmlFor="max_Temperature">{translations.max_temperature}:</label>
                        <input id="max_Temperature" type="text" className="general-input" value={max_Temperature} onChange={(e) => handleTemperatureChange(e.target.value, setMax_Temperature)} required />
                    </div>
                    <div className="input-group">
                        <label htmlFor="min_Temperature">{translations.min_temperature}:</label>
                        <input id="min_Temperature" type="text" className="general-input" value={min_Temperature} onChange={(e) => handleTemperatureChange(e.target.value, setMin_Temperature)} required />
                    </div>
                    <div className="input-group">
                        <label htmlFor="max_GroundHumidity">{translations.max_soil_moisture}:</label>
                        <input id="max_GroundHumidity" type="number" className="general-input" value={max_GroundHumidity} onChange={(e) => setMax_GroundHumidity(e.target.value)} />
                    </div>
                    <div className="input-group">
                        <label htmlFor="min_GroundHumidity">{translations.min_soil_moisture}:</label>
                        <input id="min_GroundHumidity" type="number" className="general-input" value={min_GroundHumidity} onChange={(e) => setMin_GroundHumidity(e.target.value)} />
                    </div>
                    <div className="input-group">
                        <label htmlFor="max_AirHumidity">{translations.max_air_humidity}:</label>
                        <input id="max_AirHumidity" type="number" className="general-input" value={max_AirHumidity} onChange={(e) => setMax_AirHumidity(e.target.value)} />
                    </div>
                    <div className="input-group">
                        <label htmlFor="min_AirHumidity">{translations.min_air_humidity}:</label>
                        <input id="min_AirHumidity" type="number" className="general-input" value={min_AirHumidity} onChange={(e) => setMin_AirHumidity(e.target.value)} />
                    </div>
                    <div className="input-group">
                        <label htmlFor="max_Minerals">{translations.max_minerals}:</label>
                        <input id="max_Minerals" type="number" className="general-input" value={max_Minerals} onChange={(e) => setMax_Minerals(e.target.value)} />
                    </div>
                    <div className="input-group">
                        <label htmlFor="min_Minerals">{translations.min_minerals}:</label>
                        <input id="min_Minerals" type="number" className="general-input" value={min_Minerals} onChange={(e) => setMin_Minerals(e.target.value)} />
                    </div>
                    <div className="input-group full-width">
                        <label htmlFor="sunlightLevel">{translations.sunlight_level}</label>
                        <select id="sunlightLevel" className="general-input" value={sunlightLevel} onChange={(e) => setSunlightLevel(e.target.value)} required>
                            {sunlightLevelOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="content">
                    <button onClick={() => handleSave(pot.SN)} className="general-button">{translations.apply}</button>
                </div>
            </div>
        </div>
        </>
    );
};

export default AdvancedPotSettings;
